import * as Animation from './animations';

export default Animation;
